import Link from 'next/link'

import { type NonFsdsPuckPageProps,createNonFsdsPageGetServerSideProps } from '@/lib/create-non-fsds-page-gssp'
import { useBranding } from '@/hooks/use-branding'

import NonFsdsSignUpPage from '@/components/auth/non-fsds-sign-up-page'
import { SignUpForm } from '@/components/forms/auth/sign-up-form'
import { Icons } from '@/components/icons'
import NonFsdsEditablePageShell from '@/components/puck/non-fsds-editable-page-shell'
import SEO from '@/components/seo/SEO'
import { Card } from '@/components/ui/card'

export const getServerSideProps = createNonFsdsPageGetServerSideProps('sign-up')

function SignUpPage({ puckData }: NonFsdsPuckPageProps) {
  const { isFsdsDomain } = useBranding()
  const isNonFsds = !isFsdsDomain

  if (isNonFsds) {
    return (
      <NonFsdsEditablePageShell
        slug="sign-up"
        seoTitle="Sign up"
        puckData={puckData}
        fallback={<NonFsdsSignUpPage />}
      />
    )
  }

  return (
    <div className="container grid h-svh flex-col items-center justify-center bg-background lg:max-w-none lg:px-0">
      <SEO title="Sign up" />
      <div className="mx-auto flex w-full flex-col justify-center space-y-2 sm:w-[480px] lg:p-8">
        <div className="relative z-20 flex w-full items-center justify-center text-lg font-medium">
          <Link href="/" className="inline-flex items-center">
            <Icons.logo />
          </Link>
        </div>
        <Card className="p-6">
          <div className="mb-2 flex flex-col space-y-2 text-left">
            <h1 className="text-lg font-semibold tracking-tight">Create a New Account</h1>
            <p className="text-sm text-muted-foreground">
              Please provide your information to create an account. <br />
              Already have an account?{' '}
              <Link href="/sign-in" className="underline underline-offset-4 hover:text-primary">
                Sign In
              </Link>
            </p>
          </div>
          <SignUpForm />
        </Card>
      </div>
    </div>
  )
}

export default SignUpPage
